import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "AI for your Smarthome",
  "path": "/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/",
  "dateChanged": "2025-11-25",
  "author": "Mike Polinowski",
  "excerpt": "From now on, it will be possible to use the AI of your 2K+/WQHD 4K/UHD camera directly in third-party software to recognise people, cars, animals, etc.!",
  "image": "../FAQ_SearchThumb.png",
  "social": "/images/Search/FAQ_SearchThumb.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_FAQs_white.webp",
  "chapter": "FAQs",
  "faq": "WQHD & UHD Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='AI for your Smarthome' dateChanged='2025-11-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='From now on, it will be possible to use the AI of your 2K+/WQHD 4K/UHD camera directly in third-party software to recognise people, cars, animals, etc.!' image='/images/Search/FAQ_SearchThumb.png' twitter='/images/Search/FAQ_SearchThumb.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/' locationFR='/fr/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/' crumbLabel="FAQs" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ai-for-your-smarthome",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ai-for-your-smarthome",
        "aria-label": "ai for your smarthome permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`AI for your Smarthome`}</h1>
    <p>{`From now on, it will be possible to use the AI of your 2K+/WQHD 4K/UHD camera directly in third-party software to recognise people, cars, animals, etc.! For an overview of all object classes, see also - `}<a parentName="p" {...{
        "href": "https://forum.instar.com/t/erweiterte-ai-objekterkennung-fuer-2k-wqhd-kameras/30548"
      }}>{`AI Object Recognition`}</a></p>
    <h2 {...{
      "id": "object-recognition",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#object-recognition",
        "aria-label": "object recognition permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Object Recognition`}</h2>
    <p>{`Until now, object detection could only be used indirectly. In the `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/Alarm/Actions/"
      }}>{`Alarm/Actions menu`}</a>{`, the AI model could be used as a filter to reject alarms without people/cars/animals as false alarms. The `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/Alarm/Object_Detection/"
      }}>{`Alarm/Object Detection menu`}</a>{` then allowed fine-tuning by setting a minimum and maximum size expected for the object and a threshold value for the confidence required for recognition.`}</p>
    <h3 {...{
      "id": "analysis-of-error-detections",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#analysis-of-error-detections",
        "aria-label": "analysis of error detections permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Analysis of error detections`}</h3>
    <p>{`When errors were detected by the AI model, it was previously difficult to identify the cause or determine a minimum threshold value/object size that would rule out detection.`}</p>
    <p>{`By querying the model directly, you can now obtain the raw data with the object class, the confidence with which the prediction was made, and the position in the image. This can be done with the following `}<a parentName="p" {...{
        "href": "/en/1440p_Series_CGI_List/"
      }}>{`CGI command`}</a>{`:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><code parentName="p" {...{
            "className": "language-text"
          }}>{`param.cgi?cmd=getmodelprediction&count=1&model=movingobjects`}</code></p>
        <ul parentName="li">
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`count`}</code>{`: Specifies the number of detections expected. If there is more than one object in the camera image, this must be adjusted accordingly to obtain all detections. If fewer objects are detected than specified by this value, the others are filled with ‘zero values’. This facilitates integration into third-party systems.`}</li>
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`model`}</code>{`: In future, different AI models will be available on the camera. Currently, only movingobjects is available, which is also used for alarm object detection.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`The return value of this command then looks like this, for example:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`cmd="getmodelprediction";
objects="[{"class": "person", "confidence": 0.78, "x": 1344, "y": 240, "w": 640, "h": 704}]";
response="200";`}</code></pre></div>
    <p>{`Here, the camera has detected a person in the image area with a 78% probability, whose upper corner is located at pixel x=344, y=240 (these numbers refer to the resolution of the camera image – x=0, y=0 would be the top left corner of the camera image, for example) and a width/height of 640/704 pixels.`}</p>
    <p>{`If you have placed a Santa Claus in this position, you already have an idea of what could trigger the error detection.`}</p>
    <p>{`Often it is plants, decorative lighting or similar that triggers error detection. Covering these with a `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/"
      }}>{`privacy mask`}</a>{` solves the problem! In most cases, it is sufficient to simply draw a thin bar through the centre of the object. Simply adjust, request a new prediction from the model and repeat until the detection confidence has fallen below the detection threshold.
Smart home`}</p>
    <p>{`Integration into the smart home using the command above is analogous to the `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_Testing/"
      }}>{`Advanced HTTP Alarm Server`}</a>{` (example: `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/"
      }}>{`Node-RED`}</a>{`). This is more convenient via the MQTT interface with the MQTT topic and payload:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`alarm/triggered/objects/manual`}</code>{`: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"movingobjects"}`}</code></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/8ea22/AI_for_your_Smarthome_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.47826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVQoz2WR607bQBCF/SKUQGLnZu/Gdnad9WXteO31NVfTJCROCb2oUImWH32BPkHfA1GBgAdsHaq2KkefRkeaGY10RgCqKfeI1OmLbU1s62Jblzq62Na6kGiINrtIamvNjv7Mc6uaafdbXSyEr++zzeN4+8iKu7x8mO+e8s3DM/Hqfrx9dMe3JL0xsxuS3rjj23h5505+nF8/zXb3wuTk64BuDWeD7ZLQrem9IW6FuYfQrcc/xuMvPL8K86todJWMPwfJZT77FGYXwnSS2BbCCKI+0NQuUFp/gKClyJJLB/N5PpumxTyfTuLxKIpCN2DUc4lQFCfT6dz3WRBy07RVVev1/gKhattOlo3iOPFZenq6ef/hkk++5YvvdDgR0jTN89y2bcdxLMvqvdDAMPQ+0PSurgOEej0VdGQoKyohZrW8Wq3CMPBclxACIYAA/K6gEjZQp1tviIdSs9YQDxviK1E6EKUDY4AE32fL5WkSp45N+31sGAOEDIQwwhhhA+PBgBiyIjVbx81WvdWu2JsGxkjwWbRcX+fTi9HsIsre8uw8iHcsOmPxWZjsePqOemGneyxKR1LzSJRqolSTmrV64yBJYmGxWBTzGfOHnIeM+RAoAMigqpVRFNk0ie1YlmNatukNXd8fep479L2yLIWyLIuiSJKEc25ZlmEY/6YFIbRtJ89y3/dd12OM8ZAHQcgYW6/XAmOMUmpbtmWamqapqvpf2oSQNE2TvaI4CoOAUooxXi6XgizLiqLscwUQwpevIoRUBzlP0zQMApe6lFJCyK/ln8JNwXwZltBPAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/bb86ef0894ee55ee7af21f390e3a01fc/e4706/AI_for_your_Smarthome_01.avif 230w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/d1af7/AI_for_your_Smarthome_01.avif 460w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/7f308/AI_for_your_Smarthome_01.avif 920w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/fab00/AI_for_your_Smarthome_01.avif 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/bb86ef0894ee55ee7af21f390e3a01fc/a0b58/AI_for_your_Smarthome_01.webp 230w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/bc10c/AI_for_your_Smarthome_01.webp 460w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/966d8/AI_for_your_Smarthome_01.webp 920w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/da35d/AI_for_your_Smarthome_01.webp 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/bb86ef0894ee55ee7af21f390e3a01fc/81c8e/AI_for_your_Smarthome_01.png 230w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/08a84/AI_for_your_Smarthome_01.png 460w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/c0255/AI_for_your_Smarthome_01.png 920w", "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/8ea22/AI_for_your_Smarthome_01.png 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/bb86ef0894ee55ee7af21f390e3a01fc/c0255/AI_for_your_Smarthome_01.png",
              "alt": "MQTT Explorer",
              "title": "MQTT Explorer",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The integration is then carried out in the same way as already explained for the Extended MQTT Alarm Server.`}</p>
    <p>{`This function allows you to trigger an AI request to the camera for freely definable events from the smart home and to trigger an action after finding the desired object.`}</p>
    <p>{`See also `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/"
      }}>{`Home Assistant MQTT Auto-Discovery`}</a>{` or `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/UHD_OpenHAB_MQTT_Discovery/"
      }}>{`OpenHAB MQTT Auto-Discovery`}</a>{` for fully automatic integration into your smart home!`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/en/FAQs/"
        }}>{`FAQs`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9420WQHD/"
            }}>{`IN-9420 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9408WQHD/"
            }}>{`IN-9408 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8415WQHD/"
            }}>{`IN-8415 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8403WQHD/"
            }}>{`IN-8403 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8401WQHD/"
            }}>{`IN-8401 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9020FHD/"
            }}>{`IN-9020 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9010FHD/"
            }}>{`IN-9010 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9008FHD/"
            }}>{`IN-9008 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8015FHD/"
            }}>{`IN-8015 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8003FHD/"
            }}>{`IN-8003 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8001FHD/"
            }}>{`IN-8001 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-7011HD/"
            }}>{`IN-7011 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6014HD/"
            }}>{`IN-6014 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6012HD/"
            }}>{`IN-6012 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6001HD/"
            }}>{`IN-6001 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-5907HD/"
            }}>{`IN-5907 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-5905HD/"
            }}>{`IN-5905 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/VGA_Series/"
            }}>{`VGA Series`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      